import { render, staticRenderFns } from "./TextEditItem_Ap.vue?vue&type=template&id=28ced8ec&scoped=true"
import script from "./TextEditItem_Ap.vue?vue&type=script&lang=js"
export * from "./TextEditItem_Ap.vue?vue&type=script&lang=js"
import style0 from "./TextEditItem_Ap.vue?vue&type=style&index=0&id=28ced8ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ced8ec",
  null
  
)

export default component.exports